import { render, staticRenderFns } from "./TransferReferrals.vue?vue&type=template&id=a4415b3e&scoped=true"
import script from "./TransferReferrals.vue?vue&type=script&lang=js"
export * from "./TransferReferrals.vue?vue&type=script&lang=js"
import style0 from "./TransferReferrals.vue?vue&type=style&index=0&id=a4415b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4415b3e",
  null
  
)

export default component.exports